<div class="row no-gutters swapa-featured-text-block" *ngIf="config && config.Headline">
    <div class="col-12 swapa-featured-text-block-text d-flex flex-column justify-content-center">
        <div class="swapa-featured-text-block-meta text-uppercase" *ngIf="config.Tags?.length || config.Date">
            <span class="swapa-featured-text-block-tag font-weight-bold" *ngIf="config.Tags?.length">
                <ng-container *ngFor="let tag of config.Tags; let last = last"><a class="text-reset" [href]="tag.Url">{{ tag.Text }}</a><ng-container *ngIf="!last">&nbsp;</ng-container></ng-container>
            </span>
            <span class="swapa-featured-text-block-separator" *ngIf="config.Tags?.length && config.Date">&nbsp;|&nbsp;</span>
            <span class="swapa-featured-text-block-date" *ngIf="config.Date">{{ config.Date }}</span>
        </div>
        <h2 class="swapa-featured-text-block-title font-weight-bold mt-2"><a class="text-reset" [href]="config.LinkUrl">{{ config.Headline }}</a></h2>
        <p class="swapa-featured-text-block-description mb-0" *ngIf="config.Summary"
           [clampTooltip]="config.Summary"><a class="text-reset" [href]="config.LinkUrl">{{ config.Summary }}</a></p>
    </div>
</div>
